(function() {
	'use strict';
	angular.module('voyageReport')
		.controller('editVoyageReportPopupCtrl', editVoyageReportPopupCtrl);

	function editVoyageReportPopupCtrl($uibModalInstance, $sce, modalParams, MessageService, EventManagerService, PopupManager, CommonMasterData,
			voyageReportService) {

		var vm = this;
		vm.model = {
			adminComment: "",
			showFormErrors: false
		};

		vm.modaldata = modalParams.selectedRow;

		if (!!vm.modaldata.crewComment) {
			if (!(vm.modaldata.crewComment instanceof Array)) {
				var crewComments = vm.modaldata.crewComment.split("\n");
				vm.modaldata.crewComment = crewComments;
			}
		}
		else {
			vm.modalParams.crewComment = [];
		}

		vm.masterList = {
			distributionList: modalParams.DistributionList,
			editCrewList: modalParams.DistributionList,
			assignedCrew: [],
			keywordFilter : modalParams.keywordFilter,
      redirectDepartments : modalParams.redirectDepartments
		}

		vm.selectedItem = {
			filterName: '',
			distributionListId: [],
      distributionNames: []
		};

		// set selected distribution list
		if (!!vm.modaldata.distributionList && !(vm.modaldata.distributionList instanceof Array)) {
			var distributionListId = vm.modaldata.distributionList.split(',')
				.map(Number);
			if (!!vm.masterList.editCrewList) {
				vm.masterList.editCrewList.forEach(function(editCrew) {
					if (distributionListId.indexOf(editCrew.distributionListId) > -1) {
						editCrew.isSelected = true;
					}
				});
			}
			setSelectedCrew();
		}

		vm.saveReportDetails = function() {
			if (!vm.modaldata.adminComment) vm.modaldata.adminComment = "";
			if (vm.modaldata.adminComment.length > 0) vm.model.showFormErrors = false;
			else vm.model.showFormErrors = true;
			vm.selectedItem.distributionListId = [];
			var additionalDepartments = "";
			angular.forEach(vm.masterList.assignedCrew, function(crew) {
			  if (crew.distributionListId != null) {
          vm.selectedItem.distributionListId.push(crew.distributionListId);
        }
			  else {
			    additionalDepartments = additionalDepartments + "," + crew.distributionName;
        }
			});
			if (vm.selectedItem.distributionListId.length > 0 || vm.masterList.assignedCrew > 0 || additionalDepartments !== "") {
				if (!vm.model.showFormErrors) {
					var param = {
						"voyageReportId": vm.modaldata.voyageReportId,
						"version": vm.modaldata.version,
						"adminComment": vm.modaldata.adminComment,
						"distributionListIds": vm.selectedItem.distributionListId,
						"distributionIdsForSendEmail": vm.selectedItem.distributionListId,
						"additionalEmailIds": vm.model.additionalRecipients,
            "departments" : additionalDepartments,
            "crewEmail" : vm.modaldata.submittedCrewEmail
					};
					voyageReportService.addSaveSendVoyageDetails(param, function(response) {
						MessageService.success("Saved successfully");
						PopupManager.closeModal('EDIT_VOYAGE_REPORT_DETAILS');
						EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.VOYAGE.MODEL_CLOSED, true);
					}, function(error) {
						MessageService.error(error.msg[0]);
					});
				}
			} else {
				MessageService.error("No recipients selected");
			}
		}

		vm.changeInRecipientField = function(flag) {
			if (flag === "crewType") {
				filterDistributionList();
			} else if (flag === "AddAll") {
				if (setAllCrewAsSelected()) {
					setSelectedCrew();
				}
			} else if (flag === "Add") {
				setSelectedCrew();
			} else if (flag === "RemoveAll") {
				if (setSelectedCrewAsRemoved()) {
					setRemovedCrew();
				}
			} else if (flag === "Remove") {
				setRemovedCrew();
			} else if (flag === 'filter') {
				showHideEditCrew();
			}
		};

		function showHideEditCrew() {
			vm.masterList.editCrewList.forEach(function(editCrew) {
				if (editCrew.distributionName.toLowerCase()
					.indexOf(vm.selectedItem.filterName.toLowerCase()) !== -1) {
					editCrew.hide = false;
				} else {
					editCrew.hide = true;
				}
			});
		}

		vm.showHideSelectedCrew = function() {
				vm.masterList.assignedCrew.forEach(function(assignedCrew) {
					if (assignedCrew.distributionName.toLowerCase()
						.indexOf(vm.selectedItem.assignedListFilter.toLowerCase()) !== -1) {
						assignedCrew.hide = false;
					} else {
						assignedCrew.hide = true;
					}
				});
			}

			// set assign crew list
		function setSelectedCrew() {
			if (vm.selectedItem.distributionListId == null) {
				vm.selectedItem.distributionListId = [];
			}
			if (vm.masterList.assignedCrew == null) {
				vm.masterList.assignedCrew = [];
			}
			if (!!vm.masterList.editCrewList) {
				vm.masterList.editCrewList.forEach(function(editCrew) {
					vm.selectedItem.filterName = '';
					editCrew.hide = false;
					if (editCrew.isSelected) {
						editCrew.isSelected = false;
						editCrew.isRemoved = false;
						vm.selectedItem.distributionListId.push(editCrew.distributionListId);
						vm.masterList.assignedCrew.push(editCrew);
					}
				});
			}
			filterDistributionList();
		}

		function setAllCrewAsSelected() {
			if (!!vm.masterList.editCrewList) {
				vm.masterList.editCrewList.forEach(function(editCrew) {
					editCrew.isSelected = true;
				});
			}
			return true;
		}

		function setSelectedCrewAsRemoved() {
			var selectedCrew = [];
			var selectedDistributionListIds = [];
			vm.selectedItem.assignedListFilter = '';
			if (!!vm.masterList.assignedCrew) {
				vm.masterList.assignedCrew.forEach(function(assignedCrew) {
					assignedCrew.isRemoved = true;
					assignedCrew.hide = false;
				});
			}
			return true;
		}

		function setRemovedCrew() {
			var selectedCrew = [];
			var selectedDistributionListIds = [];
			if (!!vm.masterList.assignedCrew) {
				vm.masterList.assignedCrew.forEach(function(assignCrew) {
					vm.selectedItem.assignedListFilter = '';
					assignCrew.hide = false;
					if (!assignCrew.isRemoved) {
						assignCrew.isRemoved = false;
						assignCrew.isSelected = false;
						selectedDistributionListIds.push(assignCrew.distributionListId);
						selectedCrew.push(assignCrew);
					} else {
						assignCrew.isRemoved = false;
						assignCrew.isSelected = false;
					}
				});
				vm.selectedItem.distributionListId = selectedDistributionListIds;
				vm.masterList.assignedCrew = selectedCrew;
			}
			if (!!vm.masterList.editCrewList) {
				vm.masterList.editCrewList.forEach(function(editCrew) {
					editCrew.hide = false;
				});
			}
			filterDistributionList();
		}

		function filterDistributionList() {
			var notSelectedCrewList = [];
			// set edit crew list
			vm.masterList.distributionList.forEach(function(crew) {
				var a = vm.selectedItem.distributionListId.indexOf(crew.distributionListId);
				if (vm.selectedItem.distributionListId.indexOf(crew.distributionListId) == -1) {
					notSelectedCrewList.push(crew);
				}
			});
			vm.masterList.editCrewList = notSelectedCrewList;
		}

		vm.highlight = function(haystack, needle) {
            if(!!haystack && !!needle){
            	if(!needle) {
                    return $sce.trustAsHtml(haystack);
                }
                return $sce.trustAsHtml(haystack.replace(new RegExp(needle, "gi"), function(match) {
                	return '<span class="highlightedText">' + match + '</span>';
                }));
            }
        };

        /*function highlightTextAreaKeyword(){
        	if(!!vm.masterList.keywordFilter){
        		$('textarea').highlightTextarea({
                    words: [vm.masterList.keywordFilter]
                  });
        	}
        }*/

		vm.closeMe = function() {
			PopupManager.closeModal('EDIT_VOYAGE_REPORT_DETAILS');
			EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.VOYAGE.MODEL_CLOSED, true);
		};

		vm.addSelectedCrew = function(crew, index) {
			vm.masterList.assignedCrew.push(crew);
			vm.masterList.editCrewList.splice(index, 1);
		}

		vm.addAllCrews = function() {
			vm.masterList.editCrewList = [];
			vm.masterList.assignedCrew = angular.copy(vm.masterList.distributionList);
		}

		vm.removeAllCrews = function() {
			vm.masterList.assignedCrew = [];
			vm.masterList.editCrewList = angular.copy(vm.masterList.distributionList);
		}

		vm.removeAssignedCrew = function(crew, index) {
		  if (crew.additional) {
        vm.masterList.redirectDepartments.push(crew);
      }
		  else {
        vm.masterList.editCrewList.push(crew);
      }
			vm.masterList.assignedCrew.splice(index, 1);
		}

    vm.addSelectedDepartment = function(crew, index) {
      vm.masterList.assignedCrew.push(crew);
      vm.masterList.redirectDepartments.splice(index, 1);
    }

		//highlightTextAreaKeyword();
	}
}());
